import type { CompactPlan } from '../types/types'
import type { MockCompactPlan } from './mockData'

const compactPlanFields = [
  'id',
  'ownerId',
  'due',
  'description',
  'status',
  'tasks',
  'parents',
  'children',
  'directCount',
  'propagatedCount',
  'totalCount',
  'directQuantity',
  'propagatedQuantity',
  'totalQuantity',
  'etag',
  'contractId',
  'okProgramId',
  'workspaceId',
  'purposeId'
] as const

export const toCompactPlan = (plan: MockCompactPlan): CompactPlan => {
  const compactPlan = Object.fromEntries(
    compactPlanFields.flatMap((field) =>
      field in plan ? [[field, plan[field]]] : []
    )
  ) as CompactPlan

  return {
    ...compactPlan,
    parents: plan.parents?.map((parent) =>
      typeof parent === 'object'
        ? toCompactPlan(parent as MockCompactPlan)
        : parent
    ) as CompactPlan['parents'],
    children: plan.children?.map((child) =>
      typeof child === 'object'
        ? toCompactPlan(child as MockCompactPlan)
        : child
    ) as CompactPlan['children']
  }
}
